"use client"

import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ 
  phoneNumber, 
  message = "Hello! I'm interested in your services.",
  className = "",
  noDefaultStyles = false,
}) => {
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const defaultClasses = `
    h-12 w-72
    flex items-center gap-2 px-6 py-3
    bg-green-500 hover:bg-green-600
    text-white font-medium rounded-lg
    transition-colors duration-200
    shadow-lg hover:shadow-xl
  `;

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`${noDefaultStyles ? '' : defaultClasses} ${className}`}
    >
      <MessageCircle size={20} />
      Chat with us on WhatsApp
    </button>
  );
};

export default WhatsAppButton;